import { de } from './de';

type Locale = 'de' | 'en';
const translations: Record<Locale, typeof de> = { de, en: de };

let currentLocale: Locale = 'de';

export function setLocale(locale: Locale): void {
  currentLocale = locale;
}

export function t(path: string): string {
  const keys = path.split('.');
  let result: unknown = translations[currentLocale];
  for (const key of keys) {
    if (result && typeof result === 'object') {
      result = (result as Record<string, unknown>)[key];
    } else {
      return path;
    }
  }
  return typeof result === 'string' ? result : path;
}

export function tArray(path: string): string[] {
  const keys = path.split('.');
  let result: unknown = translations[currentLocale];
  for (const key of keys) {
    if (result && typeof result === 'object') {
      result = (result as Record<string, unknown>)[key];
    } else {
      return [];
    }
  }
  return Array.isArray(result) ? result as string[] : [];
}
